import {
    SET_CHAT_IS_OPEN,
    SET_CHAT_IS_CLOSED
} from '../actions/types';

import {Map} from 'immutable';

function chatReducer(state = Map({isOpen: false}), action)
{
    switch (action.type)
    {
        case SET_CHAT_IS_OPEN:
            return setChatIsOpen(state);
        case SET_CHAT_IS_CLOSED:
            return setChatIsClosed(state);
    }

    return state;
}

function setChatIsOpen(state)
{
    return state.set('isOpen', true);
}

function setChatIsClosed(state, action)
{
    return state.set('isOpen', false);
}

export default chatReducer;



// WEBPACK FOOTER //
// ./redux/reducers/chatReducer.js